import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';

// -------------------------------------------------------------------
export class ICreateAccountSubscriptionInfo {
  inboxes: number;
  billing: string;
  plan: string;
}

@Component({
  selector: 'modal-create-account',
  template: require('./modal-create-account.component.pug'),
  styles: [require('./modal-create-account.component.css').toString()],
})
export class ModalCreateAccountComponent implements OnInit {
  form: FormGroup;

  input: ICreateAccountSubscriptionInfo;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    fb: FormBuilder,
    private organization_service: OrganizationService,
    private router: Router,
    private utilityService: UtilityService,
  ) {
    this.input = new ICreateAccountSubscriptionInfo();
    this.input.billing = 'monthly';
    this.input.inboxes = 1;
    this.input.plan = null;
    this.form = fb.group({
      'account-name': ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  private getPrice(plan) {
    let price = this.utilityService.getPricing(
      plan,
      this.input.inboxes,
      this.input.billing,
    );

    if (this.input.billing === 'yearly') {
      return '$' + price.toString() + ' / year';
    }

    return '$' + price.toString() + ' / month';
  }

  // -------------------------------------------------------------------
  getAccountName() {
    return this.form.get('account-name').value;
  }

  // -------------------------------------------------------------------
  onSelect(plan) {
    this.input.plan = plan;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  isFormValid(): boolean {
    return this.getAccountName(); // && this.input.plan != null;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let org_id = this.organization_service.getId();

    this.organization_service.createAccount(
      org_id,
      this.getAccountName(),
      result => {
        this.router.navigate(['/account/' + result.accountId.toString()]);
        this.bsModalRef.hide();
        //onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
